export default __webpack_public_path__ + "3237cd9673e3e0dcf4b08abbbd3cb75f.webp";